import type { FilterConfigItem, FilterOption } from "@shared/components/DynamicFilter/index.vue";
import { DEFAULT_PAGE_SIZE, type PaginatedQuery } from "@shared/types/list";
import { t } from "@shared/utils/i18n";
import { SYSTEM_USER_STATUS_OPTIONS } from "./status";
import type { SystemUserQueryParam } from "../types";

export type { SystemUserQueryParam };

export const DEFAULT_SYSTEM_USER_QUERY: SystemUserQueryParam = {
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
    status: "",
    roleIds: [],
    username: "",
    nick: "",
};

/** 角色筛选项由页面加载真实角色；不再使用「系统默认」占位 */
export const SYSTEM_USER_ROLE_PLACEHOLDER_OPTIONS: FilterOption[] = [];

export interface UserListRequestParams {
    page: number;
    perPage: number;
    username?: string;
    nick?: string;
    status?: number;
    roleIds?: string[];
}

export interface BuildSystemUserFilterOptions {
    showRole?: boolean;
}

function toOptionalStatus(value: number | "" | unknown): number | undefined {
    if (value === "" || value == null) return undefined;
    const raw = Array.isArray(value) ? value[0] : value;
    if (raw === "" || raw == null) return undefined;
    const n = Number(raw);
    return Number.isFinite(n) ? n : undefined;
}

/** 前端 query → 用户列表参数（limit → perPage） */
export function toUserListRequestParams(query: SystemUserQueryParam & PaginatedQuery): UserListRequestParams {
    const params: UserListRequestParams = {
        page: query.page,
        perPage: query.limit,
    };
    const username = query.username?.trim();
    if (username) params.username = username;
    const nick = query.nick?.trim();
    if (nick) params.nick = nick;
    const status = toOptionalStatus(query.status);
    if (status != null) params.status = status;
    if (query.roleIds?.length) params.roleIds = [...query.roleIds];
    return params;
}

/** 用户管理筛选：状态 +（可选）角色 + 用户名 + 姓名 */
export function buildSystemUserFilterConfig(roleOptions: FilterOption[] = SYSTEM_USER_ROLE_PLACEHOLDER_OPTIONS, options: BuildSystemUserFilterOptions = {}): FilterConfigItem[] {
    const { showRole = true } = options;
    const items: FilterConfigItem[] = [
        {
            type: "RadioButton",
            key: "status",
            label: "",
            options: [{ label: t("全部"), value: "" }, ...SYSTEM_USER_STATUS_OPTIONS],
        },
    ];
    if (showRole) {
        items.push({
            type: "UiMultipleSelect",
            key: "roleIds",
            label: t("角色"),
            placeholder: t("请选择角色"),
            options: roleOptions,
            width: 160,
        });
    }
    items.push(
        {
            type: "Input",
            key: "username",
            label: t("用户名"),
            placeholder: t("用户名"),
            width: 140,
        },
        {
            type: "Input",
            key: "nick",
            label: t("姓名"),
            placeholder: t("姓名"),
            width: 140,
        },
    );
    return items;
}
